import React, { useContext } from "react";
import { UserContext } from "./UserContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useContext(UserContext);

  if (!user) {
    // Just wait – TokenHandler will redirect
    return null;
  }

  return children;
};

export default ProtectedRoute;
